import Utils from '../../services/utils';

export const colombianCitieslabelLabelList = [
  { value: '99800', label: 'EXTRANJERO' },
  { value: '05002', label: 'ABEJORRAL' },
  { value: '54003', label: 'ABREGO' },
  { value: '05004', label: 'ABRIAQUI' },
  { value: '50006', label: 'ACACIAS' },
  { value: '27006', label: 'ACANDI' },
  { value: '41006', label: 'ACEVEDO' },
  { value: '13006', label: 'ACHI' },
  { value: '41013', label: 'AGRADO' },
  { value: '25001', label: 'AGUA DE DIOS' },
  { value: '20011', label: 'AGUACHICA' },
  { value: '68013', label: 'AGUADA' },
  { value: '17013', label: 'AGUADAS' },
  { value: '85010', label: 'AGUAZUL' },
  { value: '20013', label: 'AGUSTIN CODAZZI' },
  { value: '41016', label: 'AIPE' },
  { value: '25019', label: 'ALBAN' },
  { value: '52019', label: 'ALBAN' },
  { value: '18029', label: 'ALBANIA' },
  { value: '44035', label: 'ALBANIA' },
  { value: '68020', label: 'ALBANIA' },
  { value: '76020', label: 'ALCALA' },
  { value: '52022', label: 'ALDANA' },
  { value: '05021', label: 'ALEJANDRIA' },
  { value: '47030', label: 'ALGARROBO' },
  { value: '41020', label: 'ALGECIRAS' },
  { value: '19022', label: 'ALMAGUER' },
  { value: '15022', label: 'ALMEIDA' },
  { value: '73024', label: 'ALPUJARRA' },
  { value: '41026', label: 'ALTAMIRA' },
  { value: '27025', label: 'ALTO BAUDO' },
  { value: '13030', label: 'ALTOS DEL ROSARIO' },
  { value: '73026', label: 'ALVARADO' },
  { value: '05030', label: 'AMAGA' },
  { value: '05031', label: 'AMALFI' },
  { value: '73030', label: 'AMBALEMA' },
  { value: '25035', label: 'ANAPOIMA' },
  { value: '52036', label: 'ANCUYA' },
  { value: '76036', label: 'ANDALUCIA' },
  { value: '05034', label: 'ANDES' },
  { value: '05036', label: 'ANGELOPOLIS' },
  { value: '05038', label: 'ANGOSTURA' },
  { value: '25040', label: 'ANOLAIMA' },
  { value: '05040', label: 'ANORI' },
  { value: '17042', label: 'ANSERMA' },
  { value: '76041', label: 'ANSERMANUEVO' },
  { value: '05042', label: 'ANTIOQUIA' },
  { value: '05044', label: 'ANZA' },
  { value: '73043', label: 'ANZOATEGUI' },
  { value: '05045', label: 'APARTADO' },
  { value: '66045', label: 'APIA' },
  { value: '25599', label: 'APULO' },
  { value: '15047', label: 'AQUITANIA' },
  { value: '47053', label: 'ARACATACA' },
  { value: '17050', label: 'ARANZAZU' },
  { value: '68051', label: 'ARATOCA' },
  { value: '81001', label: 'ARAUCA' },
  { value: '81065', label: 'ARAUQUITA' },
  { value: '25053', label: 'ARBELAEZ' },
  { value: '52051', label: 'ARBOLEDA' },
  { value: '54051', label: 'ARBOLEDAS' },
  { value: '05051', label: 'ARBOLETES' },
  { value: '15051', label: 'ARCABUCO' },
  { value: '13042', label: 'ARENAL' },
  { value: '05055', label: 'ARGELIA' },
  { value: '19050', label: 'ARGELIA' },
  { value: '76054', label: 'ARGELIA' },
  { value: '47058', label: 'ARIGUANI' },
  { value: '13052', label: 'ARJONA' },
  { value: '05059', label: 'ARMENIA' },
  { value: '63001', label: 'ARMENIA' },
  { value: '73055', label: 'ARMERO' },
  { value: '13062', label: 'ARROYOHONDO' },
  { value: '20032', label: 'ASTREA' },
  { value: '73067', label: 'ATACO' },
  { value: '27050', label: 'ATRATO' },
  { value: '23068', label: 'AYAPEL' },
  { value: '27073', label: 'BAGADO' },
  { value: '27075', label: 'BAHIA SOLANO' },
  { value: '27077', label: 'BAJO BAUDO' },
  { value: '19075', label: 'BALBOA' },
  { value: '66075', label: 'BALBOA' },
  { value: '08078', label: 'BARANOA' },
  { value: '41078', label: 'BARAYA' },
  { value: '52079', label: 'BARBACOAS' },
  { value: '05079', label: 'BARBOSA' },
  { value: '68077', label: 'BARBOSA' },
  { value: '68079', label: 'BARICHARA' },
  { value: '99827', label: 'BARQUISIMETO' },
  { value: '50110', label: 'BARRANCA DE UPIA' },
  { value: '68081', label: 'BARRANCABERMEJA' },
  { value: '44078', label: 'BARRANCAS' },
  { value: '13074', label: 'BARRANCO DE LOBA' },
  { value: '94343', label: 'BARRANCO MINAS' },
  { value: '08001', label: 'BARRANQUILLA' },
  { value: '20045', label: 'BECERRIL' },
  { value: '17088', label: 'BELALCAZAR' },
  { value: '15087', label: 'BELEN' },
  { value: '52083', label: 'BELEN' },
  { value: '18094', label: 'BELEN DE LOS ANDAQUIES' },
  { value: '66088', label: 'BELEN DE UMBRIA' },
  { value: '05088', label: 'BELLO' },
  { value: '05086', label: 'BELMIRA' },
  { value: '25086', label: 'BELTRAN' },
  { value: '15090', label: 'BERBEO' },
  { value: '05091', label: 'BETANIA' },
  { value: '15092', label: 'BETEITIVA' },
  { value: '05093', label: 'BETULIA' },
  { value: '68092', label: 'BETULIA' },
  { value: '25095', label: 'BITUIMA' },
  { value: '15097', label: 'BOAVITA' },
  { value: '54099', label: 'BOCHALEMA' },
  { value: '11001', label: 'BOGOTA D.C.' },
  { value: '25099', label: 'BOJACA' },
  { value: '27099', label: 'BOJAYA' },
  { value: '05101', label: 'BOLIVAR' },
  { value: '19100', label: 'BOLIVAR' },
  { value: '68101', label: 'BOLIVAR' },
  { value: '76100', label: 'BOLIVAR' },
  { value: '20060', label: 'BOSCONIA' },
  { value: '15104', label: 'BOYACA' },
  { value: '05107', label: 'BRICEÑO' },
  { value: '15106', label: 'BRICEÑO' },
  { value: '68001', label: 'BUCARAMANGA' },
  { value: '54109', label: 'BUCARASICA' },
  { value: '76109', label: 'BUENAVENTURA' },
  { value: '15109', label: 'BUENAVISTA' },
  { value: '23079', label: 'BUENAVISTA' },
  { value: '63111', label: 'BUENAVISTA' },
  { value: '70110', label: 'BUENAVISTA' },
  { value: '19110', label: 'BUENOS AIRES' },
  { value: '99803', label: 'BUENOS AIRES - ARGENTINA' },
  { value: '52110', label: 'BUESACO' },
  { value: '76111', label: 'BUGA' },
  { value: '76113', label: 'BUGALAGRANDE' },
  { value: '05113', label: 'BURITICA' },
  { value: '15114', label: 'BUSBANZA' },
  { value: '25120', label: 'CABRERA' },
  { value: '68121', label: 'CABRERA' },
  { value: '50124', label: 'CABUYARO' },
  { value: '94886', label: 'CACAHUAL' },
  { value: '05120', label: 'CACERES' },
  { value: '25123', label: 'CACHIPAY' },
  { value: '54128', label: 'CACHIRA' },
  { value: '54125', label: 'CACOTA' },
  { value: '05125', label: 'CAICEDO' },
  { value: '76122', label: 'CAICEDONIA' },
  { value: '70124', label: 'CAIMITO' },
  { value: '73124', label: 'CAJAMARCA' },
  { value: '19130', label: 'CAJIBIO' },
  { value: '25126', label: 'CAJICA' },
  { value: '13140', label: 'CALAMAR' },
  { value: '95015', label: 'CALAMAR' },
  { value: '63130', label: 'CALARCA' },
  { value: '05129', label: 'CALDAS' },
  { value: '15131', label: 'CALDAS' },
  { value: '19137', label: 'CALDONO' },
  { value: '76001', label: 'CALI' },
  { value: '68132', label: 'CALIFORNIA' },
  { value: '76126', label: 'CALIMA' },
  { value: '19142', label: 'CALOTO' },
  { value: '05134', label: 'CAMPAMENTO' },
  { value: '08137', label: 'CAMPO D LA CRUZ' },
  { value: '41132', label: 'CAMPOALEGRE' },
  { value: '15135', label: 'CAMPOHERMOSO' },
  { value: '23090', label: 'CANALETE' },
  { value: '08141', label: 'CANDELARIA' },
  { value: '76130', label: 'CANDELARIA' },
  { value: '13160', label: 'CANTAGALLO' },
  { value: '25148', label: 'CAPARRAPI' },
  { value: '68147', label: 'CAPITANEJO' },
  { value: '25151', label: 'CAQUEZA' },
  { value: '99826', label: 'CARABOBO' },
  { value: '99815', label: 'CARACAS' },
  { value: '99812', label: 'CARACAS - VENEZUELA' },
  { value: '05142', label: 'CARACOLI' },
  { value: '05145', label: 'CARAMANTA' },
  { value: '68152', label: 'CARCASI' },
  { value: '05147', label: 'CAREPA' },
  { value: '73148', label: 'CARMEN DE APICALA' },
  { value: '25154', label: 'CARMEN DE CARUPA' },
  { value: '05148', label: 'CARMEN DE VIBORAL' },
  { value: '27150', label: 'CARMEN DEL DARIEN' },
  { value: '05150', label: 'CAROLINA' },
  { value: '13001', label: 'CARTAGENA' },
  { value: '18150', label: 'CARTAGENA DEL CHAIRA' },
  { value: '76147', label: 'CARTAGO' },
  { value: '97161', label: 'CARURU' },
  { value: '73152', label: 'CASABIANCA' },
  { value: '50150', label: 'CASTILLA LA NUEVA' },
  { value: '05154', label: 'CAUCASIA' },
  { value: '05138', label: 'CAÑASGORDAS' },
  { value: '68160', label: 'CEPITA' },
  { value: '23162', label: 'CERETE' },
  { value: '15162', label: 'CERINZA' },
  { value: '68162', label: 'CERRITO' },
  { value: '47161', label: 'CERRO SAN ANTONIO' },
  { value: '27160', label: 'CERTEGUI' },
  { value: '52240', label: 'CHACHAGÜI' },
  { value: '25168', label: 'CHAGUANI' },
  { value: '70230', label: 'CHALAN' },
  { value: '85015', label: 'CHAMEZA' },
  { value: '73168', label: 'CHAPARRAL' },
  { value: '68167', label: 'CHARALA' },
  { value: '68169', label: 'CHARTA' },
  { value: '25175', label: 'CHIA' },
  { value: '99820', label: 'CHICLAYO - PERU' },
  { value: '99821', label: 'CHICLAYO PERU' },
  { value: '73874', label: 'CHICORAL' },
  { value: '05172', label: 'CHIGORODO' },
  { value: '23168', label: 'CHIMA' },
  { value: '68176', label: 'CHIMA' },
  { value: '20175', label: 'CHIMICHAGUA' },
  { value: '54172', label: 'CHINACOTA' },
  { value: '15172', label: 'CHINAVITA' },
  { value: '17174', label: 'CHINCHINA' },
  { value: '23182', label: 'CHINU' },
  { value: '25178', label: 'CHIPAQUE' },
  { value: '68179', label: 'CHIPATA' },
  { value: '15176', label: 'CHIQUINQUIRA' },
  { value: '15232', label: 'CHIQUIZA' },
  { value: '20178', label: 'CHIRIGUANA' },
  { value: '15180', label: 'CHISCAS' },
  { value: '15183', label: 'CHITA' },
  { value: '54174', label: 'CHITAGA' },
  { value: '15185', label: 'CHITARAQUE' },
  { value: '15187', label: 'CHIVATA' },
  { value: '47170', label: 'CHIVOLO' },
  { value: '15236', label: 'CHIVOR' },
  { value: '25181', label: 'CHOACHI' },
  { value: '25183', label: 'CHOCONTA' },
  { value: '13188', label: 'CICUCO' },
  { value: '47189', label: 'CIENAGA' },
  { value: '23189', label: 'CIENAGA DE ORO' },
  { value: '15189', label: 'CIENEGA' },
  { value: '68190', label: 'CIMITARRA' },
  { value: '63190', label: 'CIRCASIA' },
  { value: '05190', label: 'CISNEROS' },
  { value: '13222', label: 'CLEMENCIA' },
  { value: '05197', label: 'COCORNA' },
  { value: '73200', label: 'COELLO' },
  { value: '25200', label: 'COGUA' },
  { value: '41206', label: 'COLOMBIA' },
  { value: '52203', label: 'COLON' },
  { value: '86219', label: 'COLON' },
  { value: '70204', label: 'COLOSO' },
  { value: '15204', label: 'COMBITA' },
  { value: '05206', label: 'CONCEPCION' },
  { value: '68207', label: 'CONCEPCION' },
  { value: '05209', label: 'CONCORDIA' },
  { value: '47205', label: 'CONCORDIA' },
  { value: '27205', label: 'CONDOTO' },
  { value: '68209', label: 'CONFINES' },
  { value: '52207', label: 'CONSACA' },
  { value: '52210', label: 'CONTADERO' },
  { value: '68211', label: 'CONTRATACION' },
  { value: '54206', label: 'CONVENCION' },
  { value: '05212', label: 'COPACABANA' },
  { value: '15212', label: 'COPER' },
  { value: '13212', label: 'CORDOBA' },
  { value: '52215', label: 'CORDOBA' },
  { value: '63212', label: 'CORDOBA' },
  { value: '19212', label: 'CORINTO' },
  { value: '99828', label: 'CORO' },
  { value: '68217', label: 'COROMORO' },
  { value: '70215', label: 'COROZAL' },
  { value: '15215', label: 'CORRALES' },
  { value: '25214', label: 'COTA' },
  { value: '23300', label: 'COTORRA' },
  { value: '15218', label: 'COVARACHIA' },
  { value: '70221', label: 'COVEÑAS' },
  { value: '73217', label: 'COYAIMA' },
  { value: '81220', label: 'CRAVO NORTE' },
  { value: '52224', label: 'CUASPUD' },
  { value: '15223', label: 'CUBARA' },
  { value: '50223', label: 'CUBARRAL' },
  { value: '15224', label: 'CUCAITA' },
  { value: '25224', label: 'CUCUNUBA' },
  { value: '54001', label: 'CUCUTA' },
  { value: '54223', label: 'CUCUTILLA' },
  { value: '15226', label: 'CUITIVA' },
  { value: '50226', label: 'CUMARAL' },
  { value: '99773', label: 'CUMARIBO' },
  { value: '52227', label: 'CUMBAL' },
  { value: '52233', label: 'CUMBITARA' },
  { value: '73226', label: 'CUNDAY' },
  { value: '18205', label: 'CURILLO' },
  { value: '68229', label: 'CURITI' },
  { value: '20228', label: 'CURUMANI' },
  { value: '05234', label: 'DABEIBA' },
  { value: '76233', label: 'DAGUA' },
  { value: '44090', label: 'DIBULLA' },
  { value: '44098', label: 'DISTRACCION' },
  { value: '73236', label: 'DOLORES' },
  { value: '05237', label: 'DON MATIAS' },
  { value: '66170', label: 'DOS QUEBRADAS' },
  { value: '15238', label: 'DUITAMA' },
  { value: '54239', label: 'DURANIA' },
  { value: '05240', label: 'EBEJICO' },
  { value: '76243', label: 'EL AGUILA' },
  { value: '05250', label: 'EL BAGRE' },
  { value: '47245', label: 'EL BANCO' },
  { value: '76246', label: 'EL CAIRO' },
  { value: '50245', label: 'EL CALVARIO' },
  { value: '27135', label: 'EL CANTON DEL SAN PABLO' },
  { value: '54245', label: 'EL CARMEN' },
  { value: '68235', label: 'EL CARMEN' },
  { value: '27245', label: 'EL CARMEN DE ATRATO' },
  { value: '13244', label: 'EL CARMEN DE BOLIVAR' },
  { value: '50251', label: 'EL CASTILLO' },
  { value: '76248', label: 'EL CERRITO' },
  { value: '52250', label: 'EL CHARCO' },
  { value: '15244', label: 'EL COCUY' },
  { value: '25245', label: 'EL COLEGIO' },
  { value: '20238', label: 'EL COPEY' },
  { value: '18247', label: 'EL DONCELLO' },
  { value: '50270', label: 'EL DORADO' },
  { value: '76250', label: 'EL DOVIO' },
  { value: '91263', label: 'EL ENCANTO' },
  { value: '15248', label: 'EL ESPINO' },
  { value: '68245', label: 'EL GUACAMAYO' },
  { value: '13248', label: 'EL GUAMO' },
  { value: '27250', label: 'EL LITORAL DEL SAN JUAN' },
  { value: '44110', label: 'EL MOLINO' },
  { value: '20250', label: 'EL PASO' },
  { value: '18256', label: 'EL PAUJIL' },
  { value: '25258', label: 'EL PENON' },
  { value: '52254', label: 'EL PEÑOL' },
  { value: '13268', label: 'EL PEÑON' },
  { value: '68250', label: 'EL PEÑON' },
  { value: '47258', label: 'EL PIÑON' },
  { value: '68255', label: 'EL PLAYON' },
  { value: '95025', label: 'EL RETORNO' },
  { value: '47268', label: 'EL RETÉN' },
  { value: '70233', label: 'EL ROBLE' },
  { value: '25260', label: 'EL ROSAL' },
  { value: '52256', label: 'EL ROSARIO' },
  { value: '52258', label: 'EL TABLON' },
  { value: '19256', label: 'EL TAMBO' },
  { value: '52260', label: 'EL TAMBO' },
  { value: '54250', label: 'EL TARRA' },
  { value: '54261', label: 'EL ZULIA' },
  { value: '41244', label: 'ELIAS' },
  { value: '68264', label: 'ENCINO' },
  { value: '68266', label: 'ENCISO' },
  { value: '05264', label: 'ENTRERRIOS' },
  { value: '05266', label: 'ENVIGADO' },
  { value: '99819', label: 'ESPAÑA' },
  { value: '73268', label: 'ESPINAL' },
  { value: '99822', label: 'ESTADOS UNIDOS - ATLANTA' },
  { value: '25269', label: 'FACATATIVA' },
  { value: '73270', label: 'FALAN' },
  { value: '17272', label: 'FILADELFIA' },
  { value: '63272', label: 'FILANDIA' },
  { value: '15272', label: 'FIRAVITOBA' },
  { value: '73275', label: 'FLANDES' },
  { value: '18001', label: 'FLORENCIA' },
  { value: '19290', label: 'FLORENCIA' },
  { value: '15276', label: 'FLORESTA' },
  { value: '68271', label: 'FLORIAN' },
  { value: '76275', label: 'FLORIDA' },
  { value: '68276', label: 'FLORIDABLANCA' },
  { value: '25279', label: 'FOMEQUE' },
  { value: '44279', label: 'FONSECA' },
  { value: '81300', label: 'FORTUL' },
  { value: '25281', label: 'FOSCA' },
  { value: '52520', label: 'FRANCIS PIZARRO' },
  { value: '05282', label: 'FREDONIA' },
  { value: '73283', label: 'FRESNO' },
  { value: '05284', label: 'FRONTINO' },
  { value: '50287', label: 'FUENTE DE ORO' },
  { value: '47288', label: 'FUNDACION' },
  { value: '52287', label: 'FUNES' },
  { value: '25286', label: 'FUNZA' },
  { value: '25288', label: 'FUQUENE' },
  { value: '25290', label: 'FUSAGASUGA' },
  { value: '25293', label: 'GACHALA' },
  { value: '25295', label: 'GACHANCIPA' },
  { value: '15293', label: 'GACHANTIVA' },
  { value: '25297', label: 'GACHETA' },
  { value: '68296', label: 'GALAN' },
  { value: '08296', label: 'GALAPA' },
  { value: '70235', label: 'GALERAS' },
  { value: '25299', label: 'GAMA' },
  { value: '20295', label: 'GAMARRA' },
  { value: '68298', label: 'GAMBITA' },
  { value: '15296', label: 'GAMEZA' },
  { value: '15299', label: 'GARAGOA' },
  { value: '41298', label: 'GARZON' },
  { value: '63302', label: 'GENOVA' },
  { value: '41306', label: 'GIGANTE' },
  { value: '76306', label: 'GINEBRA' },
  { value: '05306', label: 'GIRALDO' },
  { value: '25307', label: 'GIRARDOT' },
  { value: '05308', label: 'GIRARDOTA' },
  { value: '68307', label: 'GIRON' },
  { value: '05310', label: 'GOMEZ PLATA' },
  { value: '20310', label: 'GONZALEZ' },
  { value: '54313', label: 'GRAMALOTE' },
  { value: '05313', label: 'GRANADA' },
  { value: '25312', label: 'GRANADA' },
  { value: '50313', label: 'GRANADA' },
  { value: '68318', label: 'GUACA' },
  { value: '15317', label: 'GUACAMAYAS' },
  { value: '76318', label: 'GUACARI' },
  { value: '25317', label: 'GUACHETA' },
  { value: '52317', label: 'GUACHUCAL' },
  { value: '05315', label: 'GUADALUPE' },
  { value: '41319', label: 'GUADALUPE' },
  { value: '68320', label: 'GUADALUPE' },
  { value: '25320', label: 'GUADUAS' },
  { value: '52320', label: 'GUAITARILLA' },
  { value: '52323', label: 'GUALMATAN' },
  { value: '47318', label: 'GUAMAL' },
  { value: '50318', label: 'GUAMAL' },
  { value: '73319', label: 'GUAMO' },
  { value: '19318', label: 'GUAPI' },
  { value: '68322', label: 'GUAPOTA' },
  { value: '70265', label: 'GUARANDA' },
  { value: '05318', label: 'GUARNE' },
  { value: '25322', label: 'GUASCA' },
  { value: '05321', label: 'GUATAPE' },
  { value: '25324', label: 'GUATAQUI' },
  { value: '25326', label: 'GUATAVITA' },
  { value: '15322', label: 'GUATEQUE' },
  { value: '66318', label: 'GUATICA' },
  { value: '68324', label: 'GUAVATA' },
  { value: '25328', label: 'GUAYABAL DE SIQUIMA' },
  { value: '25335', label: 'GUAYABETAL' },
  { value: '15325', label: 'GUAYATA' },
  { value: '68327', label: 'GUEPSA' },
  { value: '15332', label: 'GUICAN' },
  { value: '25339', label: 'GUTIERREZ' },
  { value: '54344', label: 'HACARI' },
  { value: '13300', label: 'HATILLO DE LOBA' },
  { value: '68344', label: 'HATO' },
  { value: '85125', label: 'HATO COROZAL' },
  { value: '44378', label: 'HATONUEVO' },
  { value: '05347', label: 'HELICONIA' },
  { value: '99806', label: 'HENDERSON - EEUU' },
  { value: '54347', label: 'HERRAN' },
  { value: '73347', label: 'HERVEO' },
  { value: '05353', label: 'HISPANIA' },
  { value: '41349', label: 'HOBO' },
  { value: '99823', label: 'HOLANDA PB -AMSTERDAM' },
  { value: '73349', label: 'HONDA' },
  { value: '73001', label: 'IBAGUE' },
  { value: '73352', label: 'ICONONZO' },
  { value: '52352', label: 'ILES' },
  { value: '52354', label: 'IMUES' },
  { value: '94001', label: 'INIRIDA' },
  { value: '19355', label: 'INZA' },
  { value: '52356', label: 'IPIALES' },
  { value: '41357', label: 'IQUIRA' },
  { value: '41359', label: 'ISNOS' },
  { value: '27361', label: 'ISTMINA' },
  { value: '05360', label: 'ITAGUI' },
  { value: '05361', label: 'ITUANGO' },
  { value: '15362', label: 'IZA' },
  { value: '19364', label: 'JAMBALO' },
  { value: '76364', label: 'JAMUNDI' },
  { value: '05364', label: 'JARDIN' },
  { value: '15367', label: 'JENESANO' },
  { value: '05368', label: 'JERICO' },
  { value: '15368', label: 'JERICO' },
  { value: '25368', label: 'JERUSALEN' },
  { value: '68368', label: 'JESUS MARIA' },
  { value: '68370', label: 'JORDAN' },
  { value: '08372', label: 'JUAN DE ACOSTA' },
  { value: '25372', label: 'JUNIN' },
  { value: '27372', label: 'JURADO' },
  { value: '23350', label: 'LA APARTADA' },
  { value: '41378', label: 'LA ARGENTINA' },
  { value: '68377', label: 'LA BELLEZA' },
  { value: '25377', label: 'LA CALERA' },
  { value: '15380', label: 'LA CAPILLA' },
  { value: '05376', label: 'LA CEJA' },
  { value: '66383', label: 'LA CELIA' },
  { value: '91405', label: 'LA CHORRERA' },
  { value: '52378', label: 'LA CRUZ' },
  { value: '76377', label: 'LA CUMBRE' },
  { value: '17380', label: 'LA DORADA' },
  { value: '54385', label: 'LA ESPERANZA' },
  { value: '05380', label: 'LA ESTRELLA' },
  { value: '52381', label: 'LA FLORIDA' },
  { value: '20383', label: 'LA GLORIA' },
  { value: '94885', label: 'LA GUADALUPE' },
  { value: '20400', label: 'LA JAGUA DE IBIRICO' },
  { value: '44420', label: 'LA JAGUA DEL PILAR' },
  { value: '52385', label: 'LA LLANADA' },
  { value: '50350', label: 'LA MACARENA' },
  { value: '17388', label: 'LA MERCED' },
  { value: '25386', label: 'LA MESA' },
  { value: '18410', label: 'LA MONTAÑITA' },
  { value: '25394', label: 'LA PALMA' },
  { value: '20621', label: 'LA PAZ' },
  { value: '68397', label: 'LA PAZ' },
  { value: '91407', label: 'LA PEDRERA' },
  { value: '25398', label: 'LA PEÑA' },
  { value: '05390', label: 'LA PINTADA' },
  { value: '41396', label: 'LA PLATA' },
  { value: '54398', label: 'LA PLAYA' },
  { value: '99524', label: 'LA PRIMAVERA' },
  { value: '85136', label: 'LA SALINA' },
  { value: '19392', label: 'LA SIERRA' },
  { value: '63401', label: 'LA TEBAIDA' },
  { value: '52390', label: 'LA TOLA' },
  { value: '05400', label: 'LA UNION' },
  { value: '52399', label: 'LA UNION' },
  { value: '70400', label: 'LA UNION' },
  { value: '76400', label: 'LA UNION' },
  { value: '50370', label: 'LA URIBE' },
  { value: '15403', label: 'LA UVITA' },
  { value: '19397', label: 'LA VEGA' },
  { value: '25402', label: 'LA VEGA' },
  { value: '91430', label: 'LA VICTORIA' },
  { value: '15401', label: 'LA VICTORIA' },
  { value: '76403', label: 'LA VICTORIA' },
  { value: '66400', label: 'LA VIRGINIA' },
  { value: '54377', label: 'LABATECA' },
  { value: '15377', label: 'LABRANZAGRANDE' },
  { value: '68385', label: 'LANDAZURI' },
  { value: '99805', label: 'LAS VEGAS NV - EEUU' },
  { value: '68406', label: 'LEBRIJA' },
  { value: '52405', label: 'LEIVA' },
  { value: '50400', label: 'LEJANIAS' },
  { value: '25407', label: 'LENGUAZAQUE' },
  { value: '73408', label: 'LERIDA' },
  { value: '91001', label: 'LETICIA' },
  { value: '73411', label: 'LIBANO' },
  { value: '05411', label: 'LIBORINA' },
  { value: '99801', label: 'LIMA PERU' },
  { value: '52411', label: 'LINARES' },
  { value: '27413', label: 'LLORO' },
  { value: '19418', label: 'LOPEZ' },
  { value: '23417', label: 'LORICA' },
  { value: '52418', label: 'LOS ANDES' },
  { value: '23419', label: 'LOS CORDOBAS' },
  { value: '70418', label: 'LOS PALMITOS' },
  { value: '54405', label: 'LOS PATIOS' },
  { value: '68418', label: 'LOS SANTOS' },
  { value: '54418', label: 'LOURDES' },
  { value: '08421', label: 'LURUACO' },
  { value: '15425', label: 'MACANAL' },
  { value: '68425', label: 'MACARAVITA' },
  { value: '05425', label: 'MACEO' },
  { value: '25426', label: 'MACHETA' },
  { value: '25430', label: 'MADRID' },
  { value: '13430', label: 'MAGANGUE' },
  { value: '52427', label: 'MAGUI' },
  { value: '13433', label: 'MAHATES' },
  { value: '44430', label: 'MAICAO' },
  { value: '70429', label: 'MAJAGUAL' },
  { value: '68432', label: 'MALAGA' },
  { value: '08433', label: 'MALAMBO' },
  { value: '52435', label: 'MALLAMA' },
  { value: '08436', label: 'MANATI' },
  { value: '44560', label: 'MANAURE' },
  { value: '20443', label: 'MANAURE BALCON DL CESAR' },
  { value: '85139', label: 'MANI' },
  { value: '17001', label: 'MANIZALES' },
  { value: '25436', label: 'MANTA' },
  { value: '17433', label: 'MANZANARES' },
  { value: '50325', label: 'MAPIRIPAN' },
  { value: '94663', label: 'MAPIRIPANA' },
  { value: '99825', label: 'MARACAIBO' },
  { value: '99807', label: 'MARACAIBO-VENEZUELA' },
  { value: '13440', label: 'MARGARITA' },
  { value: '13442', label: 'MARIA LA BAJA' },
  { value: '05440', label: 'MARINILLA' },
  { value: '15442', label: 'MARIPI' },
  { value: '73443', label: 'MARIQUITA' },
  { value: '17442', label: 'MARMATO' },
  { value: '17444', label: 'MARQUETALIA' },
  { value: '66440', label: 'MARSELLA' },
  { value: '17446', label: 'MARULANDA' },
  { value: '68444', label: 'MATANZA' },
  { value: '05001', label: 'MEDELLIN' },
  { value: '25438', label: 'MEDINA' },
  { value: '27425', label: 'MEDIO ATRATO' },
  { value: '27430', label: 'MEDIO BAUDO' },
  { value: '27450', label: 'MEDIO SAN JUAN' },
  { value: '73449', label: 'MELGAR' },
  { value: '19450', label: 'MERCADERES' },
  { value: '50330', label: 'MESETAS' },
  { value: '18460', label: 'MILAN' },
  { value: '15455', label: 'MIRAFLORES' },
  { value: '95200', label: 'MIRAFLORES' },
  { value: '19455', label: 'MIRANDA' },
  { value: '91460', label: 'MIRITI - PARANA' },
  { value: '66456', label: 'MISTRATO' },
  { value: '97001', label: 'MITU' },
  { value: '86001', label: 'MOCOA' },
  { value: '68464', label: 'MOGOTES' },
  { value: '68468', label: 'MOLAGAVITA' },
  { value: '23464', label: 'MOMIL' },
  { value: '13468', label: 'MOMPOS' },
  { value: '15464', label: 'MONGUA' },
  { value: '15466', label: 'MONGUI' },
  { value: '15469', label: 'MONIQUIRA' },
  { value: '05467', label: 'MONTEBELLO' },
  { value: '13458', label: 'MONTECRISTO' },
  { value: '23466', label: 'MONTELIBANO' },
  { value: '63470', label: 'MONTENEGRO' },
  { value: '23001', label: 'MONTERIA' },
  { value: '85162', label: 'MONTERREY' },
  { value: '13473', label: 'MORALES' },
  { value: '19473', label: 'MORALES' },
  { value: '18479', label: 'MORELIA' },
  { value: '94888', label: 'MORICHAL' },
  { value: '70473', label: 'MORROA' },
  { value: '25473', label: 'MOSQUERA' },
  { value: '52473', label: 'MOSQUERA' },
  { value: '15476', label: 'MOTAVITA' },
  { value: '23500', label: 'MOÑITOS' },
  { value: '73461', label: 'MURILLO' },
  { value: '05475', label: 'MURINDO' },
  { value: '05480', label: 'MUTATA' },
  { value: '54480', label: 'MUTISCUA' },
  { value: '15480', label: 'MUZO' },
  { value: '05483', label: 'NARIÑO' },
  { value: '25483', label: 'NARIÑO' },
  { value: '52480', label: 'NARIÑO' },
  { value: '41483', label: 'NATAGA' },
  { value: '73483', label: 'NATAGAIMA' },
  { value: '05495', label: 'NECHI' },
  { value: '05490', label: 'NECOCLI' },
  { value: '17486', label: 'NEIRA' },
  { value: '41001', label: 'NEIVA' },
  { value: '25486', label: 'NEMOCON' },
  { value: '99818', label: 'NEW YORK - ESTADOS UNIDOS' },
  { value: '25488', label: 'NILO' },
  { value: '25489', label: 'NIMAIMA' },
  { value: '15491', label: 'NOBSA' },
  { value: '25491', label: 'NOCAIMA' },
  { value: '17495', label: 'NORCASIA' },
  { value: '27491', label: 'NOVITA' },
  { value: '47460', label: 'NUEVA GRANADA' },
  { value: '15494', label: 'NUEVO COLON' },
  { value: '85225', label: 'NUNCHIA' },
  { value: '27495', label: 'NUQUI' },
  { value: '76497', label: 'OBANDO' },
  { value: '68498', label: 'OCAMONTE' },
  { value: '54498', label: 'OCAÑA' },
  { value: '68500', label: 'OIBA' },
  { value: '15500', label: 'OICATA' },
  { value: '05501', label: 'OLAYA' },
  { value: '52490', label: 'OLAYA HERRERA' },
  { value: '68502', label: 'ONZAGA' },
  { value: '41503', label: 'OPORAPA' },
  { value: '86320', label: 'ORITO' },
  { value: '85230', label: 'OROCUE' },
  { value: '73504', label: 'ORTEGA' },
  { value: '52506', label: 'OSPINA' },
  { value: '15507', label: 'OTANCHE' },
  { value: '70508', label: 'OVEJAS' },
  { value: '15511', label: 'PACHAVITA' },
  { value: '25513', label: 'PACHO' },
  { value: '97511', label: 'PACOA' },
  { value: '17513', label: 'PACORA' },
  { value: '19513', label: 'PADILLA' },
  { value: '15514', label: 'PAEZ' },
  { value: '19517', label: 'PAEZ' },
  { value: '41518', label: 'PAICOL' },
  { value: '20517', label: 'PAILITAS' },
  { value: '25518', label: 'PAIME' },
  { value: '15516', label: 'PAIPA' },
  { value: '15518', label: 'PAJARITO' },
  { value: '41524', label: 'PALERMO' },
  { value: '17524', label: 'PALESTINA' },
  { value: '41530', label: 'PALESTINA' },
  { value: '99804', label: 'PALMA BALEARES ESPAÑA' },
  { value: '68522', label: 'PALMAR' },
  { value: '08520', label: 'PALMAR DE VARELA' },
  { value: '68524', label: 'PALMAS SOCORRO' },
  { value: '76520', label: 'PALMIRA' },
  { value: '99813', label: 'PALMIRA - VENEZUELA' },
  { value: '70523', label: 'PALMITO' },
  { value: '73520', label: 'PALOCABILDO' },
  { value: '54518', label: 'PAMPLONA' },
  { value: '54520', label: 'PAMPLONITA' },
  { value: '94887', label: 'PANA PANA' },
  { value: '25524', label: 'PANDI' },
  { value: '15522', label: 'PANQUEBA' },
  { value: '97777', label: 'PAPUNAUA' },
  { value: '68533', label: 'PARAMO' },
  { value: '25530', label: 'PARATEBUENO' },
  { value: '25535', label: 'PASCA' },
  { value: '52001', label: 'PASTO' },
  { value: '19532', label: 'PATIA(EL BORDO)' },
  { value: '15531', label: 'PAUNA' },
  { value: '15533', label: 'PAYA' },
  { value: '85250', label: 'PAZ DE ARIPORO' },
  { value: '15537', label: 'PAZ DE RIO' },
  { value: '47541', label: 'PEDRAZA' },
  { value: '20550', label: 'PELAYA' },
  { value: '17541', label: 'PENSILVANIA' },
  { value: '99802', label: 'PENSILVANIA EEUU' },
  { value: '05543', label: 'PEQUE' },
  { value: '66001', label: 'PEREIRA' },
  { value: '99816', label: 'PERU' },
  { value: '15542', label: 'PESCA' },
  { value: '05541', label: 'PEÑOL' },
  { value: '19533', label: 'PIAMONTE' },
  { value: '68547', label: 'PIEDECUESTA' },
  { value: '73547', label: 'PIEDRAS' },
  { value: '19548', label: 'PIENDAMO' },
  { value: '63548', label: 'PIJAO' },
  { value: '47545', label: 'PIJIÑO DEL CARMEN' },
  { value: '68549', label: 'PINCHOTE' },
  { value: '13549', label: 'PINILLOS' },
  { value: '08549', label: 'PIOJO' },
  { value: '15550', label: 'PISVA' },
  { value: '41548', label: 'PITAL' },
  { value: '41551', label: 'PITALITO' },
  { value: '47551', label: 'PIVIJAY' },
  { value: '73555', label: 'PLANADAS' },
  { value: '23555', label: 'PLANETA RICA' },
  { value: '47555', label: 'PLATO' },
  { value: '52540', label: 'POLICARPA' },
  { value: '08558', label: 'POLONUEVO' },
  { value: '08560', label: 'PONEDERA' },
  { value: '19001', label: 'POPAYAN' },
  { value: '85263', label: 'PORE' },
  { value: '52560', label: 'POTOSI' },
  { value: '76563', label: 'PRADERA' },
  { value: '73563', label: 'PRADO' },
  { value: '52565', label: 'PROVIDENCIA' },
  { value: '88564', label: 'PROVIDENCIA' },
  { value: '05585', label: 'PTO NARE(LAMAGDALENA)' },
  { value: '20570', label: 'PUEBLO BELLO' },
  { value: '23570', label: 'PUEBLO NUEVO' },
  { value: '66572', label: 'PUEBLO RICO' },
  { value: '05576', label: 'PUEBLORRICO' },
  { value: '47570', label: 'PUEBLOVIEJO' },
  { value: '68572', label: 'PUENTE NACIONAL' },
  { value: '52573', label: 'PUERRES' },
  { value: '86573', label: 'PUERTO  LEGUIZAMO' },
  { value: '91530', label: 'PUERTO ALEGRIA' },
  { value: '91536', label: 'PUERTO ARICA' },
  { value: '86568', label: 'PUERTO ASIS' },
  { value: '05579', label: 'PUERTO BERRIO' },
  { value: '15572', label: 'PUERTO BOYACA' },
  { value: '86569', label: 'PUERTO CAICEDO' },
  { value: '99001', label: 'PUERTO CARRENO' },
  { value: '08573', label: 'PUERTO COLOMBIA' },
  { value: '94884', label: 'PUERTO COLOMBIA' },
  { value: '50450', label: 'PUERTO CONCORDIA' },
  { value: '23574', label: 'PUERTO ESCONDIDO' },
  { value: '50568', label: 'PUERTO GAITAN' },
  { value: '86571', label: 'PUERTO GUZMAN' },
  { value: '23580', label: 'PUERTO LIBERTADOR' },
  { value: '50577', label: 'PUERTO LLERAS' },
  { value: '50573', label: 'PUERTO LOPEZ' },
  { value: '91540', label: 'PUERTO NARIÑO' },
  { value: '68573', label: 'PUERTO PARRA' },
  { value: '18592', label: 'PUERTO RICO' },
  { value: '50590', label: 'PUERTO RICO' },
  { value: '81591', label: 'PUERTO RONDON' },
  { value: '25572', label: 'PUERTO SALGAR' },
  { value: '91669', label: 'PUERTO SANTANDER' },
  { value: '54553', label: 'PUERTO SANTANDER' },
  { value: '19573', label: 'PUERTO TEJADA' },
  { value: '05591', label: 'PUERTO TRIUNFO' },
  { value: '68575', label: 'PUERTO WILCHES' },
  { value: '25580', label: 'PULI' },
  { value: '52585', label: 'PUPIALES' },
  { value: '19585', label: 'PURACE' },
  { value: '73585', label: 'PURIFICACION' },
  { value: '23586', label: 'PURISIMA' },
  { value: '25592', label: 'QUEBRADANEGRA' },
  { value: '25594', label: 'QUETAME' },
  { value: '27001', label: 'QUIBDO' },
  { value: '99824', label: 'QUIBOR' },
  { value: '63594', label: 'QUIMBAYA' },
  { value: '66594', label: 'QUINCHIA' },
  { value: '15580', label: 'QUIPAMA' },
  { value: '25596', label: 'QUIPILE' },
  { value: '99811', label: 'QUITO ECUADOR' },
  { value: '54599', label: 'RAGONVALIA' },
  { value: '15599', label: 'RAMIRIQUI' },
  { value: '15600', label: 'RAQUIRA' },
  { value: '85279', label: 'RECETOR' },
  { value: '13580', label: 'REGIDOR' },
  { value: '05604', label: 'REMEDIOS' },
  { value: '47605', label: 'REMOLINO' },
  { value: '08606', label: 'REPELON' },
  { value: '99810', label: 'REPUBLICA DOMINICANA' },
  { value: '50606', label: 'RESTREPO' },
  { value: '76606', label: 'RESTREPO' },
  { value: '05607', label: 'RETIRO' },
  { value: '25612', label: 'RICAURTE' },
  { value: '52612', label: 'RICAURTE' },
  { value: '99809', label: 'RIO DE JANEIRO - BRASIL' },
  { value: '20614', label: 'RIO DE ORO' },
  { value: '27580', label: 'RIO IRO' },
  { value: '27600', label: 'RIO QUITO' },
  { value: '13600', label: 'RIO VIEJO' },
  { value: '73616', label: 'RIOBLANCO' },
  { value: '76616', label: 'RIOFRIO' },
  { value: '44001', label: 'RIOHACHA' },
  { value: '05615', label: 'RIONEGRO' },
  { value: '68615', label: 'RIONEGRO' },
  { value: '17614', label: 'RIOSUCIO' },
  { value: '27615', label: 'RIOSUCIO' },
  { value: '17616', label: 'RISARALDA' },
  { value: '41615', label: 'RIVERA' },
  { value: '52621', label: 'ROBERTO PAYAN' },
  { value: '76622', label: 'ROLDANILLO' },
  { value: '73622', label: 'RONCESVALLES' },
  { value: '15621', label: 'RONDON' },
  { value: '19622', label: 'ROSAS' },
  { value: '73624', label: 'ROVIRA' },
  { value: '68655', label: 'SABANA DE TORRES' },
  { value: '08634', label: 'SABANAGRANDE' },
  { value: '05628', label: 'SABANALARGA' },
  { value: '08638', label: 'SABANALARGA' },
  { value: '85300', label: 'SABANALARGA' },
  { value: '47660', label: 'SABANAS DE SAN ANGEL' },
  { value: '05631', label: 'SABANETA' },
  { value: '15632', label: 'SABOYA' },
  { value: '85315', label: 'SACAMA' },
  { value: '15638', label: 'SACHICA' },
  { value: '23660', label: 'SAHAGUN' },
  { value: '41660', label: 'SALADOBLANCO' },
  { value: '17653', label: 'SALAMINA' },
  { value: '47675', label: 'SALAMINA' },
  { value: '54660', label: 'SALAZAR' },
  { value: '73671', label: 'SALDAÑA' },
  { value: '63690', label: 'SALENTO' },
  { value: '05642', label: 'SALGAR' },
  { value: '15646', label: 'SAMACA' },
  { value: '17662', label: 'SAMANA' },
  { value: '52678', label: 'SAMANIEGO' },
  { value: '70670', label: 'SAMPUES' },
  { value: '41668', label: 'SAN AGUSTIN' },
  { value: '20710', label: 'SAN ALBERTO' },
  { value: '05647', label: 'SAN ANDRES' },
  { value: '88001', label: 'SAN ANDRES' },
  { value: '68669', label: 'SAN ANDRES' },
  { value: '23670', label: 'SAN ANDRES SOTAVENTO' },
  { value: '23672', label: 'SAN ANTERO' },
  { value: '73675', label: 'SAN ANTONIO' },
  { value: '68673', label: 'SAN BENITO' },
  { value: '70678', label: 'SAN BENITO ABAD' },
  { value: '25649', label: 'SAN BERNARDO' },
  { value: '52685', label: 'SAN BERNARDO' },
  { value: '23675', label: 'SAN BERNARDO DEL VIENTO' },
  { value: '54670', label: 'SAN CALIXTO' },
  { value: '05649', label: 'SAN CARLOS' },
  { value: '23678', label: 'SAN CARLOS' },
  { value: '50680', label: 'SAN CARLOS GUAROA' },
  { value: '25653', label: 'SAN CAYETANO' },
  { value: '54673', label: 'SAN CAYETANO' },
  { value: '13620', label: 'SAN CRISTOBAL' },
  { value: '99829', label: 'SAN CRISTOBAL TACHIRA' },
  { value: '20750', label: 'SAN DIEGO' },
  { value: '15660', label: 'SAN EDUARDO' },
  { value: '13647', label: 'SAN ESTANISLAO' },
  { value: '94883', label: 'SAN FELIPE' },
  { value: '13650', label: 'SAN FERNANDO' },
  { value: '05652', label: 'SAN FRANCISCO' },
  { value: '25658', label: 'SAN FRANCISCO' },
  { value: '86755', label: 'SAN FRANCISCO' },
  { value: '68679', label: 'SAN GIL' },
  { value: '13654', label: 'SAN JACINTO' },
  { value: '13655', label: 'SAN JACINTO DEL CAUCA' },
  { value: '05656', label: 'SAN JERONIMO' },
  { value: '68682', label: 'SAN JOAQUIN' },
  { value: '18610', label: 'SAN JOSE DE FRAGUA' },
  { value: '05658', label: 'SAN JOSE DE LA MONTAÑA' },
  { value: '68684', label: 'SAN JOSE DE MIRANDA' },
  { value: '15664', label: 'SAN JOSE DE PARE' },
  { value: '95001', label: 'SAN JOSE DEL GUAVIARE' },
  { value: '27660', label: 'SAN JOSE DEL PALMAR' },
  { value: '17665', label: 'SAN JOSÉ' },
  { value: '50683', label: 'SAN JUAN DE ARAMA' },
  { value: '70702', label: 'SAN JUAN DE BETULIA' },
  { value: '25662', label: 'SAN JUAN DE RIO SECO' },
  { value: '05659', label: 'SAN JUAN DE URABA' },
  { value: '44650', label: 'SAN JUAN DEL CESAR' },
  { value: '13657', label: 'SAN JUAN NEPOMUCENO' },
  { value: '50686', label: 'SAN JUANITO' },
  { value: '52687', label: 'SAN LORENZO' },
  { value: '05660', label: 'SAN LUIS' },
  { value: '73678', label: 'SAN LUIS' },
  { value: '15667', label: 'SAN LUIS DE GACENO' },
  { value: '85325', label: 'SAN LUIS DE PALENQUE' },
  { value: '70708', label: 'SAN MARCOS' },
  { value: '20770', label: 'SAN MARTIN' },
  { value: '50689', label: 'SAN MARTIN' },
  { value: '13667', label: 'SAN MARTIN DE LOBA' },
  { value: '15673', label: 'SAN MATEO' },
  { value: '86757', label: 'SAN MIGUEL' },
  { value: '68686', label: 'SAN MIGUEL' },
  { value: '15676', label: 'SAN MIGUEL DE SEMA' },
  { value: '70713', label: 'SAN ONOFRE' },
  { value: '13670', label: 'SAN PABLO' },
  { value: '52693', label: 'SAN PABLO' },
  { value: '15681', label: 'SAN PABLO DE BORBUR' },
  { value: '05664', label: 'SAN PEDRO' },
  { value: '70717', label: 'SAN PEDRO' },
  { value: '76670', label: 'SAN PEDRO' },
  { value: '52694', label: 'SAN PEDRO DE CARTAGO' },
  { value: '05665', label: 'SAN PEDRO DE URABA' },
  { value: '23686', label: 'SAN PELAYO' },
  { value: '05667', label: 'SAN RAFAEL' },
  { value: '05670', label: 'SAN ROQUE' },
  { value: '19693', label: 'SAN SEBASTIAN' },
  { value: '47692', label: 'SAN SEBASTIAN BUENAVIST' },
  { value: '05674', label: 'SAN VICENTE' },
  { value: '68689', label: 'SAN VICENTE DE CHUCURI' },
  { value: '18753', label: 'SAN VICENTE DEL CAGUAN' },
  { value: '47703', label: 'SAN ZENON' },
  { value: '25645', label: 'SANANTONIO DEL TEQUENDAMA' },
  { value: '52683', label: 'SANDONA' },
  { value: '47707', label: 'SANTA ANA' },
  { value: '05679', label: 'SANTA BARBARA' },
  { value: '52696', label: 'SANTA BARBARA' },
  { value: '68705', label: 'SANTA BARBARA' },
  { value: '47720', label: 'SANTA BARBARA DE PINTO' },
  { value: '13673', label: 'SANTA CATALINA' },
  { value: '68720', label: 'SANTA HELENA DEL OPON' },
  { value: '73686', label: 'SANTA ISABEL' },
  { value: '08675', label: 'SANTA LUCIA' },
  { value: '15690', label: 'SANTA MARIA' },
  { value: '41676', label: 'SANTA MARIA' },
  { value: '47001', label: 'SANTA MARTA' },
  { value: '13683', label: 'SANTA ROSA' },
  { value: '19701', label: 'SANTA ROSA' },
  { value: '66682', label: 'SANTA ROSA DE CABAL' },
  { value: '05686', label: 'SANTA ROSA DE OSOS' },
  { value: '15693', label: 'SANTA ROSA DE VITERBO' },
  { value: '13688', label: 'SANTA ROSA DEL SUR' },
  { value: '99624', label: 'SANTA ROSALIA' },
  { value: '15696', label: 'SANTA SOFIA' },
  { value: '52699', label: 'SANTACRUZ' },
  { value: '15686', label: 'SANTANA' },
  { value: '19698', label: 'SANTANDER DE QUILICHAO' },
  { value: '54680', label: 'SANTIAGO' },
  { value: '86760', label: 'SANTIAGO' },
  { value: '05690', label: 'SANTO DOMINGO' },
  { value: '08685', label: 'SANTO TOMAS' },
  { value: '05697', label: 'SANTUARIO' },
  { value: '66687', label: 'SANTUARIO' },
  { value: '52720', label: 'SAPUYES' },
  { value: '81736', label: 'SARAVENA' },
  { value: '54720', label: 'SARDINATA' },
  { value: '25718', label: 'SASAIMA' },
  { value: '15720', label: 'SATIVANORTE' },
  { value: '15723', label: 'SATIVASUR' },
  { value: '05736', label: 'SEGOVIA' },
  { value: '25736', label: 'SESQUILE' },
  { value: '76736', label: 'SEVILLA' },
  { value: '15740', label: 'SIACHOQUE' },
  { value: '25740', label: 'SIBATE' },
  { value: '86749', label: 'SIBUNDOY' },
  { value: '54743', label: 'SILOS' },
  { value: '25743', label: 'SILVANIA' },
  { value: '19743', label: 'SILVIA' },
  { value: '68745', label: 'SIMACOTA' },
  { value: '25745', label: 'SIMIJACA' },
  { value: '13744', label: 'SIMITI' },
  { value: '70742', label: 'SINCE' },
  { value: '70001', label: 'SINCELEJO' },
  { value: '27745', label: 'SIPI' },
  { value: '47745', label: 'SITIONUEVO' },
  { value: '25754', label: 'SOACHA' },
  { value: '15753', label: 'SOATA' },
  { value: '15757', label: 'SOCHA' },
  { value: '68755', label: 'SOCORRO' },
  { value: '15755', label: 'SOCOTA' },
  { value: '15759', label: 'SOGAMOSO' },
  { value: '18756', label: 'SOLANO' },
  { value: '08758', label: 'SOLEDAD' },
  { value: '18785', label: 'SOLITA' },
  { value: '15761', label: 'SOMONDOCO' },
  { value: '05756', label: 'SONSON' },
  { value: '05761', label: 'SOPETRAN' },
  { value: '13760', label: 'SOPLAVIENTO' },
  { value: '25758', label: 'SOPO' },
  { value: '15762', label: 'SORA' },
  { value: '15764', label: 'SORACA' },
  { value: '15763', label: 'SOTAQUIRA' },
  { value: '19760', label: 'SOTARA' },
  { value: '99817', label: 'STAMFORD-CONNECTICUT' },
  { value: '68770', label: 'SUAITA' },
  { value: '08770', label: 'SUAN' },
  { value: '19780', label: 'SUAREZ' },
  { value: '73770', label: 'SUAREZ' },
  { value: '41770', label: 'SUAZA' },
  { value: '25769', label: 'SUBACHOQUE' },
  { value: '19785', label: 'SUCRE' },
  { value: '68773', label: 'SUCRE' },
  { value: '70771', label: 'SUCRE' },
  { value: '25772', label: 'SUESCA' },
  { value: '25777', label: 'SUPATA' },
  { value: '17777', label: 'SUPIA' },
  { value: '68780', label: 'SURATA' },
  { value: '25779', label: 'SUSA' },
  { value: '15774', label: 'SUSACON' },
  { value: '15776', label: 'SUTAMARCHAN' },
  { value: '25781', label: 'SUTATAUSA' },
  { value: '15778', label: 'SUTATENZA' },
  { value: '25785', label: 'TABIO' },
  { value: '27787', label: 'TADO' },
  { value: '13780', label: 'TALAIGUA NUEVO' },
  { value: '20787', label: 'TAMALAMEQUE' },
  { value: '85400', label: 'TAMARA' },
  { value: '81794', label: 'TAME' },
  { value: '05789', label: 'TAMESIS' },
  { value: '52786', label: 'TAMINANGO' },
  { value: '52788', label: 'TANGUA' },
  { value: '97666', label: 'TARAIRA' },
  { value: '91798', label: 'TARAPACA' },
  { value: '05790', label: 'TARAZA' },
  { value: '41791', label: 'TARQUI' },
  { value: '05792', label: 'TARSO' },
  { value: '15790', label: 'TASCO' },
  { value: '85410', label: 'TAURAMENA' },
  { value: '25793', label: 'TAUSA' },
  { value: '41799', label: 'TELLO' },
  { value: '25797', label: 'TENA' },
  { value: '47798', label: 'TENERIFE' },
  { value: '25799', label: 'TENJO' },
  { value: '15798', label: 'TENZA' },
  { value: '54800', label: 'TEORAMA' },
  { value: '41801', label: 'TERUEL' },
  { value: '41797', label: 'TESALIA' },
  { value: '25805', label: 'TIBACUY' },
  { value: '15804', label: 'TIBANA' },
  { value: '15806', label: 'TIBASOSA' },
  { value: '25807', label: 'TIBIRITA' },
  { value: '54810', label: 'TIBU' },
  { value: '23807', label: 'TIERRALTA' },
  { value: '41807', label: 'TIMANA' },
  { value: '19807', label: 'TIMBIO' },
  { value: '19809', label: 'TIMBIQUI' },
  { value: '15808', label: 'TINJACA' },
  { value: '15810', label: 'TIPACOQUE' },
  { value: '13810', label: 'TIQUISIO' },
  { value: '05809', label: 'TITIRIBI' },
  { value: '15814', label: 'TOCA' },
  { value: '25815', label: 'TOCAIMA' },
  { value: '25817', label: 'TOCANCIPA' },
  { value: '15816', label: 'TOGUI' },
  { value: '05819', label: 'TOLEDO' },
  { value: '54820', label: 'TOLEDO' },
  { value: '70820', label: 'TOLU' },
  { value: '70823', label: 'TOLUVIEJO' },
  { value: '68820', label: 'TONA' },
  { value: '15820', label: 'TOPAGA' },
  { value: '25823', label: 'TOPAIPI' },
  { value: '19821', label: 'TORIBIO' },
  { value: '76823', label: 'TORO' },
  { value: '15822', label: 'TOTA' },
  { value: '19824', label: 'TOTORO' },
  { value: '85430', label: 'TRINIDAD' },
  { value: '76828', label: 'TRUJILLO' },
  { value: '08832', label: 'TUBARA' },
  { value: '76834', label: 'TULUA' },
  { value: '52835', label: 'TUMACO' },
  { value: '15001', label: 'TUNJA' },
  { value: '15832', label: 'TUNUNGUA' },
  { value: '52838', label: 'TUQUERRES' },
  { value: '13836', label: 'TURBACO' },
  { value: '13838', label: 'TURBANA' },
  { value: '05837', label: 'TURBO' },
  { value: '15835', label: 'TURMEQUE' },
  { value: '15837', label: 'TUTA' },
  { value: '15839', label: 'TUTASA' },
  { value: '25839', label: 'UBALA' },
  { value: '25841', label: 'UBAQUE' },
  { value: '25843', label: 'UBATE' },
  { value: '76845', label: 'ULLOA' },
  { value: '15842', label: 'UMBITA' },
  { value: '25845', label: 'UNE' },
  { value: '27800', label: 'UNGUIA' },
  { value: '27810', label: 'UNION PANAMERICANA' },
  { value: '05842', label: 'URAMITA' },
  { value: '44847', label: 'URIBIA' },
  { value: '05847', label: 'URRAO' },
  { value: '44855', label: 'URUMITA' },
  { value: '08849', label: 'USIACURI' },
  { value: '25851', label: 'UTICA' },
  { value: '05854', label: 'VALDIVIA' },
  { value: '23855', label: 'VALENCIA' },
  { value: '99808', label: 'VALENCIA - VENEZUELA' },
  { value: '68855', label: 'VALLE DE SAN JOSE' },
  { value: '73854', label: 'VALLE DE SAN JUAN' },
  { value: '86865', label: 'VALLE GUAMUEZ' },
  { value: '20001', label: 'VALLEDUPAR' },
  { value: '05856', label: 'VALPARAISO' },
  { value: '18860', label: 'VALPARAISO' },
  { value: '05858', label: 'VEGACHI' },
  { value: '68861', label: 'VELEZ' },
  { value: '73861', label: 'VENADILLO' },
  { value: '05861', label: 'VENECIA' },
  { value: '25506', label: 'VENECIA' },
  { value: '99814', label: 'VENEZUELA' },
  { value: '15861', label: 'VENTAQUEMADA' },
  { value: '25862', label: 'VERGARA' },
  { value: '76863', label: 'VERSALLES' },
  { value: '68867', label: 'VETAS' },
  { value: '25867', label: 'VIANI' },
  { value: '17867', label: 'VICTORIA' },
  { value: '05873', label: 'VIGIA DEL FUERTE' },
  { value: '76869', label: 'VIJES' },
  { value: '54871', label: 'VILLA CARO' },
  { value: '15407', label: 'VILLA DE LEYVA' },
  { value: '54874', label: 'VILLA DEL ROSARIO' },
  { value: '19845', label: 'VILLA RICA' },
  { value: '86885', label: 'VILLAGARZON' },
  { value: '25871', label: 'VILLAGOMEZ' },
  { value: '73870', label: 'VILLAHERMOSA' },
  { value: '17873', label: 'VILLAMARIA' },
  { value: '13873', label: 'VILLANUEVA' },
  { value: '85440', label: 'VILLANUEVA' },
  { value: '44874', label: 'VILLANUEVA' },
  { value: '68872', label: 'VILLANUEVA' },
  { value: '25873', label: 'VILLAPINZON' },
  { value: '73873', label: 'VILLARRICA' },
  { value: '50001', label: 'VILLAVICENCIO' },
  { value: '41872', label: 'VILLAVIEJA' },
  { value: '25875', label: 'VILLETA' },
  { value: '25878', label: 'VIOTA' },
  { value: '15879', label: 'VIRACACHA' },
  { value: '50711', label: 'VISTA HERMOSA' },
  { value: '17877', label: 'VITERBO' },
  { value: '25885', label: 'YACOPI' },
  { value: '52885', label: 'YACUANQUER' },
  { value: '41885', label: 'YAGUARA' },
  { value: '05885', label: 'YALI' },
  { value: '05887', label: 'YARUMAL' },
  { value: '97889', label: 'YAVARATÉ' },
  { value: '05890', label: 'YOLOMBO' },
  { value: '05893', label: 'YONDO' },
  { value: '85001', label: 'YOPAL' },
  { value: '76890', label: 'YOTOCO' },
  { value: '76892', label: 'YUMBO' },
  { value: '13894', label: 'ZAMBRANO' },
  { value: '68895', label: 'ZAPATOCA' },
  { value: '47960', label: 'ZAPAYAN' },
  { value: '05895', label: 'ZARAGOZA' },
  { value: '76895', label: 'ZARZAL' },
  { value: '15897', label: 'ZETAQUIRA' },
  { value: '25898', label: 'ZIPACON' },
  { value: '25899', label: 'ZIPAQUIRA' },
  { value: '47980', label: 'ZONA BANANERA' }
];

export const colombianCitiesLabelsObject = Utils.valueLabelListToLabelsObject(colombianCitieslabelLabelList);
